// src/components/steps/AdditionalEnvStep.js
import React from 'react';
import UatEnvironmentInfo from '../UatEnvironmentInfo';
import DrEnvironmentInfo from '../DrEnvironmentInfo';

function AdditionalEnvStep({ state, setState, serviceData, exchangeRate }) {
  return (
    <div className="space-y-6">
      <div className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Additional Environments</h2>
        <p className="text-gray-600 mb-6">Configure your testing and disaster recovery environments</p>
      </div>
      <div className="space-y-4">
        <div className="flex items-center p-4 border-2 border-gray-200 rounded-xl hover:bg-gray-50 cursor-pointer">
          <label className="flex items-center cursor-pointer w-full">
            <input
              type="checkbox"
              checked={state.uatServer}
              onChange={e => setState(prev => ({ ...prev, uatServer: e.target.checked, uatWorkload: e.target.checked ? state.workload: '' }))}
              className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
            />
            <span className="ml-3 flex-grow">
              <span className="block text-lg font-medium text-gray-900">Deploy UAT environment on a separate server</span>
              <span className="block text-sm text-gray-500">Recommended</span>
            </span>
          </label>
          <UatEnvironmentInfo />
        </div>

        {/* UAT Workload Selection (Conditional) */}
        {state.uatServer && (
          <div className="p-4 border-2 border-gray-200 rounded-xl">
            <label className="block text-lg font-medium text-gray-900 mb-2">Select UAT Workload</label>
            <select
              value={state.uatWorkload}
              onChange={e => setState(prev => ({ ...prev, uatWorkload: e.target.value }))}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="" disabled>Select Workload</option>
              {Object.entries(serviceData.instanceTypes).map(([key, value]) => (
                <option key={key} value={key}>{value.name} ({value.instance})</option>
              ))}
            </select>
          </div>
        )}

        <div className="flex items-center p-4 border-2 border-gray-200 rounded-xl hover:bg-gray-50 cursor-pointer">
          <label className="flex items-center cursor-pointer w-full">
            <input
              type="checkbox"
              checked={state.drServer}
              onChange={e => setState(prev => ({ ...prev, drServer: e.target.checked, drWorkload: e.target.checked ? state.workload: '' }))}
              className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
            />
            <span className="ml-3">
              <span className="block text-lg font-medium text-gray-900">Include DR Server</span>
              <span className="block text-sm text-gray-500">Near real-time data replication with 10-second recovery point</span>
            </span>
          </label>
          <DrEnvironmentInfo />
        </div>

        {/* DR Workload Selection (Conditional) */}
        {state.drServer && (
          <div className="p-4 border-2 border-gray-200 rounded-xl">
            <label className="block text-lg font-medium text-gray-900 mb-2">Select DR Workload</label>
            <select
              value={state.drWorkload}
              onChange={e => setState(prev => ({ ...prev, drWorkload: e.target.value }))}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="" disabled>Select Workload</option>
              {Object.entries(serviceData.instanceTypes).map(([key, value]) => (
                <option key={key} value={key}>{value.name} ({value.instance})</option>
              ))}
            </select>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdditionalEnvStep;

